<template>
    <div>
      <h1>Konfiguration ändern</h1>
      <div v-show="!showCustomConfig">
        <b-card v-for="(item, key) in products"
                v-if=" key !== 'custom'"
                class="inline m-2">
          <template v-slot:header>
            {{item.product_name}}
          </template>
          <b-card-body>
            <b-container class="text-center">
              <table style="margin-left: 0px;">
                <tr>
                  <td style="text-align: right;"><b>{{item.cores}}</b></td>
                  <td style="text-align: left;">Kerne</td>
                </tr>
                <tr>
                  <td style="text-align: right;"><b>{{item.memory}}</b></td>
                  <td style="text-align: left;">MB RAM</td>
                </tr>
                <tr>
                  <td style="text-align: right;"><b>{{item.disk}}</b></td>
                  <td style="text-align: left;">GB Disk</td>
                </tr>
                <tr>
                  <td style="text-align: right;"><b>{{item.backups}}</b></td>
                  <td style="text-align: left;">x Backup</td>
                </tr>
                <tr>
                  <td style="text-align: right;"><b>{{item.addresses_v4}}</b></td>
                  <td style="text-align: left;">IP's</td>
                </tr>
                <tr v-if="priceList">
                  <td style="text-align: right;"><b>{{priceCalculator(item)}}</b></td>
                  <td style="text-align: left;">€ / Monat</td>
                </tr>

              </table>
            </b-container>
          </b-card-body>
          <template v-slot:footer>
            <b-link @click="chooseProduct(key)">{{key === productName ? 'Auswahl' : 'Auswählen'}} <i v-show="key === productName" class="fa fa-check"></i> </b-link>
          </template>
        </b-card>

      </div>
      <b-button style="max-width: 560px;"
                variant="outline-primary"
                @click="showCustomConfig = !showCustomConfig, productName=''"
                class="col-12 mt-4 mb-4">
        {{showCustomConfig ? 'Zu den Paketen':'Selbst Konfigurieren'}}
      </b-button>
      <div v-show="showCustomConfig">
        <b-container
          style="max-width: 320px;">

          <table class="mt-4 mb-4">
            <tr v-for="(key,index) in priceKeys"
                :key="index"
                v-if="prices[key]"
                style="min-width: 280px;">
              <td class="pr-2">
                {{ $t('vservers.general')[key] }}
                <p style="color: red;" v-if="forbidDiskSizeReduction && key === 'disk'">
                  {{forbidDiskSizeReduction}}
                </p>
              </td>
              <td>
                <b-form-input
                  v-model="configModel[key]"
                  type="range"
                  :min="prices[key].min_units"
                  :max="prices[key].max_units"
                  :step="prices[key].step">
                </b-form-input>
              </td>
              <td style="text-align: left;">
                <b class="ml-2">{{configModel[key]}}</b>
              </td>
            </tr>
          </table>
          <h2>Preis: {{priceSum}} €</h2>
          <b-button class="mb-2 mt-2"
                    @click="productName='custom'">Einstellungen übernehmen</b-button>
        </b-container>
      </div>
      <hr>
      <b-button @click="$bvModal.show('upgrade')"
                :disabled="!productName"
                class="mt-2">{{!productName ? 'Paket wählen':'Upgrade starten'}}
      </b-button>
      <b-modal id="upgrade">
        Bitte geben die Vserver ID ein, um den Upgrade zu bestätigen.
        Vserver ID: <b>{{vid}}</b>
        <template v-slot:modal-footer>
          <b-input v-model="validation" type="number"></b-input>
          <b-button v-show="Number(validation) === Number(vid) ? true : false"
                    variant="outline-success"
                    @click="sendConfig()">
            Abschicken
          </b-button>
        </template>
      </b-modal>
    </div>
</template>

<script>
  import {VserverPrices} from "@/store/models/vserver/vserver_prices";
  import {VserverProducts} from "@/mixins/vserver_products";
  import {Vserver} from "@/store/models/vserver/vserver";
  import axios from "@/store/vue-axios"

  export default {
      name: "luma-config-vserver",
      data: ()=>({
          currentDiskSize:null,
          validation:'',
          productName:'',
          showCustomConfig:false,
          configModel:{
              cores:0,
              max_backups:0,
              memory:0,
              disk:0,
              addresses_v4:0,
              backups:0
          }
      }),
      created(){
          Object.keys(this.configModel).map(el=>{
              this.configModel[el] = this.vserver[el]
          })
          this.configModel['backups'] = this.vserver['max_backups']
          this.currentDiskSize = this.checkDiskSize
      },
      computed:{
          forbidDiskSizeReduction(){
              if(this.checkDiskSize < this.currentDiskSize) return 'Aus technischen Gründen ist ein Downgrade der Festplatte nicht möglich.'
              return undefined
          },
          checkDiskSize(){
              return Number(this.configModelC.disk)
          },
          productConfig(){
              if(this.productName === 'custom') return this.configModelC
              return this.products[this.productName]
          },
          priceSum(){
              if(!this.priceList) return
              return Number(this.priceList.reduce((sum, x) => sum + x)).toFixed(1)
          },
          priceList(){
              return this.priceKeys.map(el=>this.newPrice[el])
          },
          newPrice(){
              const x = {}
              this.priceKeys.map(el=>{x[el]= Number(this.configModelC[el]) / this.prices[el].step * Number(this.prices[el].price)})
              return x
          },
          configModelC(){
              return this.configModel
          },
          vserver(){
             return Vserver.find(this.vid)
          },
          vid(){
              return this.$route.params.id
          },
          products(){
              return VserverProducts
          },
          prices(){
              if(VserverPrices.all().length === 0) return VserverPrices.pricingVservers()
              const x = {}
              VserverPrices.all().map(el=>{
                  x[el.unit]=el
              })
              return x || undefined
          },
          priceKeys(){
              return Object.keys(this.prices) || undefined
          }
      },
      methods:{
          chooseProduct(key){
            this.productName = key
          },
          createConfig(){
              const config = {}
              const x = Object.keys(this.configModelC).map(el=>{
                  config[el]=this.productConfig[el]
              })
              !this.productConfig['max_backups'] ? config['max_backups'] = this.configModelC['backups'] : config['max_backups'] = this.configModelC['backups']
              console.log('PRODCONF::::',config)
              return config
          },
          sendConfig(){
              const x = this.createConfig()
              const y = axios.put("/datacenter/vservers/"+ this.vid +"/upgrade", x)
              return this.$router.push({name:'vservers-list'})
          },
          priceCalculator(config){
              const x = VserverPrices.priceCalculator(config)
              console.log('pC:::: ',x)
              return x
          }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datacenter/vserver_datacenter/luma-config-vserver.vue